import React, { useState } from 'react'
import { deleteFile } from '../../../../services/genericService'
import { TiDelete } from 'react-icons/ti'
import styles from './images.module.css'
import Confirm from '../../../common/modals/confirm'
import { Col, Row } from 'react-bootstrap'

type Props = {
  id?: string
  imageArray?: string[]
  imageSrc?: string
  onImageDelete?: any
  onImageTouched?: () => void
}

const ImageContainer = ({
  id,
  imageArray,
  imageSrc,
  onImageDelete,
  onImageTouched
}: Props) => {
  const [showModal, setShowModal] = useState(false)

  return (
    <div className="mb-1">
      {imageSrc ? (
        <>
          <Row>
            <Col>
              <Confirm
                show={showModal}
                body={
                  'Are you sure you want to delete this image? (Note: this image will be permanently deleted in the system)'
                }
                confirmText="Ok"
                onConfirmClick={async () => {
                  if (onImageTouched) {
                    onImageTouched()
                  }

                  // delete file in array
                  onImageDelete!(imageArray?.indexOf(imageSrc))
                  // delete file from firebase storage
                  deleteFile(imageSrc)
                  setShowModal(false)
                }}
                onCancelClick={() => setShowModal(false)}
              />
              <img
                src={imageSrc}
                width="100%"
                height=""
                alt="thumbnail"
                className={`${styles.imageThumbnail}`}
                data-testid="with-image"
              />
              <div
                className={styles.removePhoto}
                data-testid="edit-changing-image"
              >
                <h3>
                  <TiDelete
                    className="text-danger"
                    data-testid="delete-image"
                    onClick={() => setShowModal(true)}
                  />
                </h3>
              </div>
            </Col>
          </Row>
        </>
      ) : (
        <img
          src="/image.png"
          className={styles.imageContainerDotted}
          width="100%"
          alt="thumbnail"
          data-testid="no-image"
        />
      )}
    </div>
  )
}

export default ImageContainer
